<ng-container>
  <h1 *ngIf="title" [style.color]="color" class="title">{{ title }}</h1>
  <div class="tos-item-detail" *ngFor="let item of items; let i = index">
    <div class="video-container" *ngIf="item?.video_type && item?.url">
      <bepatient-video
        [video]="{ videoType: item?.video_type, url: item?.url }"
      ></bepatient-video>
    </div>
    <p *ngIf="item.text" [innerHtml]="item.text"></p>
  </div>
</ng-container>
